<script>
import { Bar } from 'vue-chartjs'
import moment from 'moment'
export default {
    extends: Bar,
    data() {
        var devnumbers = _.map(this.devices, 'number');
        var devids = _.map(this.devices, 'id');
        var propsByInspectionId = _.groupBy(this.properties, 'inspection_id');
        var inspdics = _.keyBy(this.inspections, 'id');
        var inspids =  _.map(this.inspections, 'id');
        var that = this;
        var graphdata = {
                    label: this.$t('routine_analyses.graphs.pieces'),
                    data: [
                        _.map(inspids, (c) => { 
                            _.sum(
                                _.map(
                                   _.filter( _.uniqBy(
                                        _.flatten(_.map(propsByInspectionId[c], 'property_pests_filtered')), 'id'
                                    ), {pest_id: parseInt(that.pest_id)}), 'quantity'
                                )
                            )
                        })
                    ],
                    fill: false,
                    borderColor: that.color,
                    backgroundColor: that.color,
                    borderWidth: 1
             };
        return {
            chartData: {
                datasets: [ {
                        label: this.$t('routine_analyses.graphs.pieces'),
                        data: _.map(inspids, (c) => {
                            return _.sum(
                                _.map(
                                    _.filter(_.uniqBy(
                                        _.flatten(_.map(propsByInspectionId[c], 'property_pests_filtered')), 'id'
                                    ), {pest_id: parseInt(that.pest_id)}), 'quantity'
                                )
                            );
                        }),
                        fill: false,
                        borderColor: that.color,
                        backgroundColor: that.color,
                        borderWidth: 1
                    }],
                 labels: _.map(inspids, (c) => {
                    return moment((inspdics[c] || []).date).format('D.M.YYYY');
                 }),
            },
            options: {
                scales: {
                    yAxes: [{
                       ticks: {
                            stepSize: 1,
                            beginAtZero: true,
                        },
                        gridLines: {
                            display: true
                        },
                        label: this.$t('routine_analyses.graphs.devices')
                    }],
                    xAxes: [{
                        ticks: {
                            stepSize: 1,
                            beginAtZero: true,
                        },
                        gridLines: {
                            display: false
                        },
                        label: this.$t('routine_analyses.graphs.pests_quantities')
                    }]
                },
                legend: {
                    display: false
                },
                spanGaps: true,
                responsive: false,
                maintainAspectRatio: false
            }
        }
    },
    props: {
        properties: Array,
        inspections: Array,
        devices: Object,
        orderby: String,
        pest_id: String
    },
    mounted() {
        this.renderChart(this.chartData, this.options)
    }
}
</script>